import {
  Component,
  OnInit
} from '@angular/core';

import {
  Router
} from '@angular/router';

import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../services/user.service';
import {NotificationService} from '../../services/notification.service';

import {NestasToolbarComponent} from '../toolbar/toolbar.component';
import {ContactComponent} from '../contact/contact.component';


import * as _ from 'lodash';

@Component({
  selector: 'expired',
  templateUrl: './expired.component.html',
  styleUrls: ['./expired.component.scss']
})
export class ExpiredComponent implements OnInit{
  success: boolean = false;

  constructor(public translate: TranslateService, private _userService: UserService, private _router: Router, private _notification: NotificationService){

  }

  ngOnInit(){
  }

  canExtend(){
    return (this._userService.me()['email'] && !this._userService.me()['extendedTrial']);
  }

  done(){
    this._router.navigate(['']);
  }

  extendTrial(){
    this._userService.extendTrial()
      .subscribe(
        (user: any) => {
          this.success = true;
          this._userService.me()['role'] = 'trial';
          this._userService.me()['extendedTrial'] = true;
          this._userService.me()['trialDaysLeft'] = user.trialDaysLeft;
        },
        err => {
          this._notification.errorServer(err);
        }
      );
  }
}
